import React from "react";
import type { ApolloClient } from "@apollo/client";
import { connect, type ConnectedProps } from "react-redux";
import { withApollo, type WithApolloClient } from "@apollo/client/react/hoc";
import { getLinkedEmployees } from "actions/employerActions";
import { createLoadingSelector } from "store/selectors";
import { employerConstants } from "actions/types";

import ProcessOneTimeGroupsTable from "./ProcessOneTimeGroupsTable";
import IconSpinner from "components/IconSpinner";
import {
  getAllEmployerAccounts,
  getAllEmployerGroups,
} from "actions/employerActions";
import type { RootState } from "types/state";

const isFetchingSelector = createLoadingSelector([
  employerConstants.GET_LINKED_EMPLOYEES,
  employerConstants.GET_EMPLOYER_ACCOUNTS,
  employerConstants.GET_EMPLOYER_GROUPS,
]);

const mapStateToProps = (state: RootState) => {
  return {
    isFetching: isFetchingSelector(state),
  };
};

const mapDispatchToProps = {
  getLinkedEmployees,
  getAllEmployerAccounts,
  getAllEmployerGroups,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type Props = WithApolloClient<ConnectedProps<typeof connector>>;

class ProcessOneTimeContributions extends React.Component<Props> {
  componentDidMount() {
    window.analytics.page("Employer Process One-Time Contributions");
    void this.props.getLinkedEmployees(
      this.props.client as ApolloClient<object>
    );
    void this.props.getAllEmployerAccounts(
      this.props.client as ApolloClient<object>
    );
    void this.props.getAllEmployerGroups(
      this.props.client as ApolloClient<object>
    );
  }

  render() {
    let content;
    if (this.props.isFetching) {
      content = <IconSpinner centered />;
    } else {
      content = <ProcessOneTimeGroupsTable />;
    }
    return (
      <div className="mega-container">
        <section className="page-title-wrap">
          <article className="text-cell">
            <h1 className="page-title">Process One-Time Contributions</h1>
            <p className="page-subtext">
              Process a one-time payroll contribution for any pay period.
            </p>
          </article>
        </section>
        <div className="main-content">{content}</div>
      </div>
    );
  }
}

export default connector(withApollo<Props>(ProcessOneTimeContributions));
